const { html } = window;

export default ({ members }) => `
<div class="row">
    <div class="columns small-12">
        <div class="Members-title">
            <h1 class="header-xsmall Members-heading">${html('libraryLinks')}</h1>
            ${!members || !members.length ? html('members.noLibLinks') : ''}
        </div>
    </div>
</div>
`;
